import { RefreshableItem } from '../../models/refreshableItem';

export enum GeneratedReportStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

export type GeneratedReport = {
  idParameterName: string;
  reportId: string;
  reportType: string;
  status: GeneratedReportStatus;
};

export enum AccountDialogType {
  NONE = 'NONE',
  MULTI = 'MULTI',
  SINGLE = 'SINGLE',
}

export type ReportDescriptionResponse = {
  products: string[];
  refreshItems: RefreshableItem[];
  accountDialogType: AccountDialogType;
};

export type ReportAccount = {
  id: string;
  accountNumber: string;
  name: string;
  holderName: string;
  financialInstitutionId: string;
  iban: string;
};

export type ReportAccountsResponse = {
  accountDialogOptions: ReportAccount[];
};

export type GenerateReportResponse = {
  userReports: GeneratedReport[];
};

export type GenerationJob = { id: string };

export type GenerateReportAsyncResponse = GenerationJob;

export enum ReportType {
  TRANSACTION_REPORT = 'TRANSACTION_REPORT',
  INCOME_CHECK_REPORT = 'INCOME_CHECK_REPORT',
  RISK_INSIGHTS_REPORT = 'RISK_INSIGHTS_REPORT',
  ACCOUNT_VERIFICATION_REPORT = 'ACCOUNT_VERIFICATION_REPORT',
  BUSINESS_ACCOUNT_VERIFICATION_REPORT = 'BUSINESS_ACCOUNT_VERIFICATION_REPORT',
  EXPENSE_CHECK_REPORT = 'EXPENSE_CHECK_REPORT',
}
